<script lang="ts">
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import { getPromoOffAmount } from '$lib/utils/stripe';
	import type { StripePaymentMethodMessagingElement } from '@stripe/stripe-js';
	import type { Stripe } from 'stripe';

	interface Props {
		id: string;
		amount?: number;
		coupon?: Stripe.Coupon;
		class?: string;
	}

	let { amount = 99900, coupon, id, class: className }: Props = $props();

	let amountOff = $derived(coupon ? getPromoOffAmount(amount, coupon) : 0);
	let totalAmount = $derived(Math.max(0, amount - amountOff));

	let paymentElement = $state<StripePaymentMethodMessagingElement>();

	async function loadStripe() {
		const stripe = await (await import('$lib/utils/stripe.client')).getStripeClient();

		const elements = stripe.elements({
			appearance: {
				variables: {
					colorText: 'rgb(84, 51, 255)',
					colorTextSecondary: 'rgb(84, 51, 255)',
					fontSizeBase: '14px',
					spacingUnit: '10px',
					fontFamily: 'Jane, ui-sans-serif, system-ui'
				}
			}
		});
		paymentElement = elements.create('paymentMethodMessaging', {
			amount: totalAmount,
			currency: 'USD',
			paymentMethodTypes: ['affirm'],
			countryCode: 'US'
		});
		paymentElement.mount(`#${id}`);
	}

	$effect(() => {
		if (paymentElement) {
			paymentElement.update({ amount: totalAmount });
		}
	});
</script>

<div
	class={className}
	{id}
	use:checkVisibility
	onvisible={({ detail }) => {
		if (!detail || paymentElement) return;

		loadStripe();
	}}
></div>
